import React from 'react';

export const ValidationPanel: React.FC<{
  codes: string[];
  onAddQr: () => void;
  onFixQr?: () => void;
}> = ({ codes, onAddQr, onFixQr }) => codes.length ? (
  <div role="alert" className="border border-amber-300 bg-amber-50 p-3 rounded-md text-sm text-amber-900">
    <strong>Design needs attention</strong>
    <ul className="list-disc ml-5 mt-1">
      {codes.includes('QR_MISSING') && <li>Add a valid Intrlock QR code.</li>}
      {codes.includes('QR_TARGET_INVALID') && <li>QR must point to the selected property and intercom.</li>}
      {codes.includes('QR_TOO_SMALL') && <li>QR is too small for reliable printing and scanning.</li>}
      {codes.includes('QR_QUIET_ZONE') && <li>QR needs more clear space around it.</li>}
      {codes.includes('QR_CONTRAST') && <li>QR colors need more contrast.</li>}
    </ul>
    <div className="flex gap-2 mt-2">
      {codes.includes('QR_MISSING') && <button className="px-3 py-1 bg-emerald-700 text-white" onClick={onAddQr}>Add required QR</button>}
      {!codes.includes('QR_MISSING') && onFixQr && <button className="px-3 py-1 bg-emerald-700 text-white" onClick={onFixQr}>Fix QR</button>}
    </div>
  </div>
) : null;
